import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Alert, Button, Card, CardBody, CardGroup, Col, Container,
    Input, InputGroup, InputGroupAddon, InputGroupText, Row,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import logo from '../../../assets/img/brand/logo.png';
import { login, } from '../../../api/Login'
import * as actions from '../../../actions';
import { submitChangePassword } from '../../../api/ChangePassword';
import { signUpUserEntry, signupvarifyphone, duplicatedUser } from '../../../api/SignUp';
import 'react-intl-tel-input/dist/main.css';
import { LoadingSpinner } from '../../../components';
import Countdown from 'react-countdown';
import Dashboard from '../../Dashboard/Dashboard';

const imageExt = ".jpg, .png, .jpeg, .gif, .bmp, .tiff";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changeScreen: false,
            errorMessage: "",
            loginId: "",
            displayName: "",
            password: "",
            newPassword: "",
            confirmPassword: "",
            attempts: 0,
            rowKey: 0,
            attemptsMessge: "",
            timestamp: undefined,
            roleName: "",
            userId: "",
            email: "",
            phoneNo: "",
            isActive: true,
            OTPModal: false,
            OTPValue: "",
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: "",
            otp5: "",
            otp6: "",
            isLoading: false,
            isTimeout: false,
        }
    };
    updateState(prop, value) {
        if (prop === "loginId") this.setState({ attempts: 0 })
        this.setState({
            [prop]: value
        })
    }
    validateChangePassword() {
        if (this.state.newPassword !== this.state.confirmPassword) {
            this.setState({
                errorMessage: "password do not match"
            })
            return false;
        } if (this.state.newPassword === "" || this.state.confirmPassword === "") {
            this.setState({
                errorMessage: "all fields must be fill"
            })
            return false;
        }

        return true
    }
    validate() {
        let { displayName, loginId, password, confirmPassword } = this.state;
        if (password !== confirmPassword && confirmPassword !== "") {
            this.setState({
                errorMessage: "password do not match"
            })
            return false;
        } if (displayName === "" || loginId === "" || password === "" || confirmPassword === "") {
            this.setState({
                errorMessage: "all fields must be fill"
            })
            return false;
        }

        return true;
    }
    async ChangePassword() {
        if (this.validateChangePassword() === false) return;
        this.setState({ errorMessage: "" })
        let chgres = await submitChangePassword(this.state);
        if (chgres.status) {
            let { pathname } = window.location;
            this.props.keepUser(chgres.data);
            if (pathname === '/') {
                this.props.history.push({ pathname: `/` })
            }
        } else {
            this.setState({
                errorMessage: chgres.message
            })
        }
    }
    toggle() {
        this.setState({ OTPModal: !this.state.OTPModal, isTimeout: !this.state.isTimeout });
    }
    async submitHandle() {
        if (this.validate() === false) return;
        this.setState({ isLoading: true, errorMessage: "" });
        let varifyphone = "";
        let Response_duplicatedUser = await duplicatedUser(this.state.loginId);
        // console.log("Response_duplicatedUser" , Response_duplicatedUser);
        if (Response_duplicatedUser.data.status) {
            varifyphone = await signupvarifyphone(this.state.loginId); //OTP verify phone number
            // console.log(varifyphone);
            //network connection is failed
            if (varifyphone.status === false) {
                this.setState({ errorMessage: "Something is wrong, Please Click the Create button again!", OTPModal: false, isLoading: false });
            } else {
                //input user is already existed in DB
                if (varifyphone.status === false) {
                    this.setState({ errorMessage: varifyphone.message, OTPModal: false, isLoading: false });
                    //Show OTP Model
                } else {
                    this.setState({ OTPModal: !this.state.OTPModal, OTPValue: varifyphone.data, isLoading: false });
                }
            }
        } else {
            this.setState({ isLoading: false, errorMessage: "This User is already existed" });
        }
    }
    ToLoginPage() {
        this.props.history.push({ pathname: "/" })
    }

    //Image func
    onDropImage(file) { //drop file
        let error = this.onDropValidation(file);
        if (!error) {
            this.setState({
                tmpDropImage: file,
                imageCropperModal: true,
            })
        }
    }
    onDropValidation(file) { //validate drop file extensions & limitation
        if (!file) {
            this.setState({
                imageErrorModal: true,
                imageErrorModalMessage: `File must not upload except ${imageExt} extensions.`
            });
            return true;
        }
        if (this.state.Image.length >= 3) {
            this.setState({
                imageErrorModal: true,
                imageErrorModalMessage: "Photo must not upload more than 3."
            });
            return true;
        }
        return false;
    }
    setCroppedImage() { //create Image (Info, base64) 
        let imgArray = this.state.Image.slice();
        imgArray.push(this.cropper.crop());
        this.setState({
            Image: imgArray,
            tmpDropImage: null,
            imageCropperModal: false
        })
    }
    deleteImage(index) { //delete Image (Info, base64)
        let imageArray = this.state.Image.slice();
        let imageArrayToDel = this.state.photosToDelete;
        let removedImage = imageArray.splice(index, 1).slice()[0];
        if (removedImage.indexOf("static/") !== -1) {
            imageArrayToDel.push(removedImage);
        }
        this.setState({
            Image: imageArray.slice(),
            photosToDelete: imageArrayToDel.slice()
        })
    }
    toggle(prop) { //close modal
        this.setState({
            [prop]: false,
            imageErrorModalMessage: "",
            tmpDropImage: null,
        });
    }
    handleChange(value1, event) {
        this.setState({ [value1]: event.target.value });
    }
    ToCancel() {
        this.setState({ OTPModal: false })
    }
    async handleSubmit() {
        const { otp1, otp2, otp3, otp4, otp5, otp6 } = this.state;
        let newString = `${otp1}${otp2}${otp3}${otp4}${otp5}${otp6}`;
        this.setState({ isLoading: true });
        // console.log("newString" , newString);
        // console.log("this.state.OTPValue" , this.state.OTPValue);
        // console.log("this.state.loginId" , this.state.loginId);
        if (newString === this.state.OTPValue) {
            let res = await signUpUserEntry(this.state);
            if (res.status) {
                this.setState({ isLoading: false });
                let response = await login(this.state, res.data);
                if (response.status) {
                    this.props.history.push({ pathname: Dashboard.routeName })
                    this.props.keepUser(response.data);
                } else {
                    this.setState({
                        errorMessage: response.message,
                        attemptsMessge: "",
                    })
                }
            } else {
                this.setState({
                    errorMessage: res.message,
                    attemptsMessge: "",
                    isLoading: false,
                    OTPValue: "",
                    OTPModal: false,
                    otp1: "",
                    otp2: "",
                    otp3: "",
                    otp4: "",
                    otp5: "",
                    otp6: "",
                    phoneNo: "",
                    loginId: "",
                    displayName: "",
                    password: "",
                    confirmPassword: ""
                });
                this.props.history.push({ pathname: `/SignUp`, state: 0 });
            }
        } else {
            this.setState({ errorMessage: "OTP Code is Invalid , Please try again!" });
        }

    }
    inputfocus = (elmnt) => {
        if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
            const next = elmnt.target.tabIndex - 2;
            if (next > -1) {
                elmnt.target.form.elements[next].focus()
            }
        }
        else {
            const next = elmnt.target.tabIndex;
            if (next < 6) {
                elmnt.target.form.elements[next].focus();
            }
        }

    }
    async resendOTP() {
        this.setState({ isLoading: true });
        let varifyphone = await signupvarifyphone(this.state.loginId);
        // console.log(varifyphone);
        if (varifyphone.status === false) {
            this.setState({ errorMessage: varifyphone.message, OTPModal: false, isLoading: false });
        } else {
            if (varifyphone.status === true) {
                this.setState({ OTPValue: varifyphone.data, isLoading: false, isTimeout: false });
            } else {
                this.setState({ errorMessage: "Something is wrong, Please Click the Create button again!", OTPModal: false, isLoading: false });
            }
        }
    }
    renderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            this.setState({ isTimeout: !this.state.isTimeout })
            // Render a completed state
            return null;
        } else {
            // Render a countdown
            return <span>{minutes}:{seconds}</span>;
        }
    }
    //1800000
    render() {
        return (
            <div className="app flex-row align-items-center">
                {!this.state.changeScreen ?
                    <Container>
                        {this.state.isLoading && <LoadingSpinner />}
                        <Modal autoFocus={false} style={{ marginTop: 0, marginBottom: 0 }} isOpen={this.state.OTPModal} toggle={() => this.toggle()} className="app flex-row align-items-center" size="lg" >
                            <ModalHeader>OTP Verification</ModalHeader>
                            <ModalBody >
                                {(!this.state.isTimeout) ? <>
                                    <div style={{ textAlign: 'center', fontWeight: 'bold' }}>We Have sent you One Time Password (OTP) to your Phone Number</div>
                                    <div style={{ textAlign: 'center', marginTop: 10, marginBottom: 10 }}>Please Enter OTP</div>
                                    {/* <div style={{ textAlign: 'center', marginTop: 10, marginBottom: 10 }}>Your OTP Code is {this.state.OTPValue}</div> */}
                                    <div style={{ textAlign: 'center', marginTop: 20, marginBottom: 50 }}><Countdown date={Date.now() + 300000} renderer={this.renderer}></Countdown></div>
                                    <form>
                                        <Row style={{ justifyContent: 'center', marginBottom: 50 }}>

                                            <Input
                                                autoFocus={true}
                                                style={{ width: 45 }}
                                                bsSize="lg"
                                                name="otp1"
                                                type="text"
                                                autoComplete="off"
                                                className="square border border-10"
                                                value={this.state.otp1}
                                                onChange={e => this.handleChange("otp1", e)}
                                                tabIndex="1" maxLength="1" onKeyUp={e => this.inputfocus(e)}
                                            />
                                            &nbsp;&nbsp;&nbsp;
                                            <Input
                                                style={{ width: 45 }}
                                                bsSize="lg"
                                                name="otp2"
                                                type="text"
                                                autoComplete="off"
                                                className="square border border-1"
                                                value={this.state.otp2}
                                                onChange={e => this.handleChange("otp2", e)}
                                                tabIndex="2" maxLength="1" onKeyUp={e => this.inputfocus(e)}

                                            />
                                            &nbsp;&nbsp;&nbsp;
                                            <Input
                                                style={{ width: 45 }}
                                                bsSize="lg"
                                                name="otp3"
                                                type="text"
                                                autoComplete="off"
                                                className="square border border-1"
                                                value={this.state.otp3}
                                                onChange={e => this.handleChange("otp3", e)}
                                                tabIndex="3" maxLength="1" onKeyUp={e => this.inputfocus(e)}

                                            />
                                            &nbsp;&nbsp;&nbsp;
                                            <Input
                                                style={{ width: 45 }}
                                                bsSize="lg"
                                                name="otp4"
                                                type="text"
                                                autoComplete="off"
                                                className="square border border-1"
                                                value={this.state.otp4}
                                                onChange={e => this.handleChange("otp4", e)}
                                                tabIndex="4" maxLength="1" onKeyUp={e => this.inputfocus(e)}
                                            />
                                            &nbsp;&nbsp;&nbsp;
                                            <Input
                                                style={{ width: 45 }}
                                                bsSize="lg"
                                                name="otp5"
                                                type="text"
                                                autoComplete="off"
                                                className="square border border-1"
                                                value={this.state.otp5}
                                                onChange={e => this.handleChange("otp5", e)}
                                                tabIndex="5" maxLength="1" onKeyUp={e => this.inputfocus(e)}
                                            />
                                            &nbsp;&nbsp;&nbsp;
                                            <Input
                                                style={{ width: 45 }}
                                                bsSize="lg"
                                                name="otp6"
                                                type="text"
                                                autoComplete="off"
                                                className="square border border-1"
                                                value={this.state.otp6}
                                                onChange={e => this.handleChange("otp6", e)}
                                                tabIndex="6" maxLength="1" onKeyUp={e => this.inputfocus(e)}
                                            />

                                        </Row>
                                    </form>
                                    {this.state.errorMessage !== "" &&
                                        <Alert color="danger">{this.state.errorMessage}</Alert>
                                    }
                                </>
                                    :
                                    <>
                                        <div style={{ fontWeight: 'bold', textAlign: 'center' }}>Your OTP Code is Expired , Please try again !</div>
                                    </>}
                            </ModalBody>
                            <ModalFooter style={{ justifyContent: 'center' }}>
                                {(!this.state.isTimeout) ?
                                    <>
                                        <Button color="secondary" onClick={() => this.ToCancel()}>Cancel</Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button color="primary" onClick={() => this.handleSubmit()}>Verify OTP</Button>
                                    </>
                                    :
                                    <>
                                        <Button color="secondary" onClick={() => this.ToCancel()}>Cancel</Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button color="primary" onClick={() => this.resendOTP()}>Resend OTP</Button>
                                    </>
                                }
                            </ModalFooter>
                        </Modal>
                        <Row className="justify-content-center">
                            <Col md="8">
                                <CardGroup>
                                    <Card className="p-4">
                                        <CardBody>
                                            <form action="">
                                                <h1>Sign Up</h1>
                                                <p className="text-muted">Create New Account with Phone Number</p>

                                                <InputGroup className="mb-3">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-phone"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input autoFocus="autofocus" type="text" name="loginId" value={this.state.loginId} onChange={(e) => this.updateState("loginId", e.target.value)} placeholder="Phone Number" />
                                                </InputGroup>

                                                <InputGroup className="mb-3">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-user-o"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="text" name="displayName" value={this.state.displayName} onChange={(e) => this.updateState("displayName", e.target.value)} placeholder="Name" />
                                                </InputGroup>


                                                <InputGroup className="mb-3">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-lock fa-lg"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="password" value={this.state.password} onChange={(e) => this.updateState("password", e.target.value)} placeholder="Password" />
                                                </InputGroup>


                                                <InputGroup className="mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-check-circle-o"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="confirmpassword" value={this.state.confirmPassword} onChange={(e) => this.updateState("confirmPassword", e.target.value)} placeholder="Confirm Password" />
                                                </InputGroup>

                                                {this.state.errorMessage !== "" &&
                                                    <Alert color="danger">{this.state.errorMessage}</Alert>
                                                }

                                                <Row>
                                                    <Col xs="6">
                                                        <Button color="primary" className="px-4" type="button" onClick={() => this.ToLoginPage()
                                                        }>Cancel</Button>
                                                    </Col>
                                                    <Col xs="6" className="text-right">
                                                        <Button color="primary" className="px-4" type="button" onClick={() => this.submitHandle()
                                                        }>Sign Up</Button>
                                                    </Col>
                                                </Row>
                                            </form>
                                        </CardBody>
                                    </Card>


                                    {/* <Card className="text-white bg-light py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                                        <FormGroup>
                                            <Dropzone
                                                style={{ border: '2px dashed LightGray', padding: 10 }}
                                                ref={(node) => { dropzoneRef = node }}
                                                accept={imageExt}
                                                onDrop={(file) => this.onDropImage(file[0])}
                                                disableClick={true}
                                                multiple={true}
                                                maxsize={2000000} // 2MB
                                            >
                                                <Button outline color="success" onClick={() => dropzoneRef.open()}>Choose File</Button>&nbsp;&nbsp;Or Drop File<br /><br />
                                                {(this.state.Image.length > 0) ?
                                                    <Row lg="12" xs="12">
                                                        {this.state.Image.map((path, index) =>
                                                            <Col key={index} lg="4" xs="4" width="200" height="300">
                                                                <div>Images ({index + 1}) &nbsp;
                                                                    <span className="fa fa-trash-o fa-lg" style={{ color: "red", cursor: "pointer" }}
                                                                        onClick={() => this.deleteImage(index)}></span>
                                                                    <CardImg draggable="false" src={path}></CardImg>
                                                                </div>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                    :
                                                    <ul><li style={{ color: 'black' }}>&nbsp;&nbsp;No file choosen</li></ul>
                                                }
                                            </Dropzone>
                                        </FormGroup>

                                        <Modal isOpen={this.state.imageErrorModal} toggle={() => this.toggle("imageErrorModal")}>
                                            <ModalHeader toggle={() => this.toggle("imageErrorModal")}>Photo Message</ModalHeader>
                                            <ModalBody>
                                                {this.state.imageErrorModalMessage}
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={() => this.toggle("imageErrorModal")}>Close</Button>
                                            </ModalFooter>
                                        </Modal>

                                        <Modal isOpen={this.state.imageCropperModal} toggle={() => this.toggle("imageCropperModal")}>
                                            <ModalHeader toggle={() => this.toggle("imageCropperModal")}>Uploaded Photo</ModalHeader>
                                            <ModalBody>
                                                <Cropper
                                                    src={this.state.tmpDropImage ? this.state.tmpDropImage.preview : ''}
                                                    ref={cropRef => { this.cropper = cropRef }}
                                                    ratio={3 / 2}
                                                    width={250}
                                                />
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="success" disabled={!this.state.imageCropperModal} onClick={() => this.setCroppedImage()}>Upload</Button>
                                                <Button color="secondary" onClick={() => this.toggle("imageCropperModal")}>Cancel</Button>
                                            </ModalFooter>
                                        </Modal>
                                    </Card> */}

                                    <Card className="text-white bg-light py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                                        <CardBody className="text-center">
                                            <div >
                                                <br /><br />
                                                <img src={logo} width="250" height="250" alt="ELM" />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardGroup>
                            </Col>
                        </Row>
                    </Container>
                    :
                    <Container>
                        <Row className="justify-content-center">
                            <Col md="8">
                                <CardGroup>
                                    <Card className="p-4">
                                        <CardBody>
                                            {this.state.errorMessage !== "" &&
                                                <Alert color="danger">{this.state.errorMessage}</Alert>
                                            }
                                            <form action="">
                                                <p className="text-muted">Please Change Your Password</p>
                                                <InputGroup className="mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-lock fa-lg"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="newpassword" value={this.state.newPassword} onChange={(e) => this.updateState("newPassword", e.target.value)} placeholder="New Password" />
                                                </InputGroup>
                                                <InputGroup className="mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-lock fa-lg"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="confirmpassword" value={this.state.confirmPassword} onChange={(e) => this.updateState("confirmPassword", e.target.value)} placeholder="Confirm Password" />
                                                </InputGroup>
                                                <Row>
                                                    <Col xs="6">
                                                        <Button color="primary" className="px-4" type="button" onClick={() => this.ChangePassword()
                                                        }>Change</Button>
                                                    </Col>
                                                </Row>
                                            </form>
                                        </CardBody>
                                    </Card>
                                    <Card className="text-white bg-light py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                                        <CardBody className="text-center">
                                            <div >
                                                <br /><br />
                                                <img src={logo} width="300" height="auto" alt="GNM" />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardGroup>
                                {
                                    this.state.attemptsMessge !== "" &&
                                    <Alert toggle={() => this.setState({ attemptsMessge: "" })} color="warning"><strong>{this.state.attemptsMessge}</strong></Alert>
                                }
                            </Col>
                        </Row>
                    </Container>
                }
            </div>
        );
    }
}
function mapStateToProps(state) {
    return { auth: state.auth };
}

export default connect(mapStateToProps, actions)(Login);
